<template>
	<div class="task">
		<XStateHeader />
		<XHeaderNav theme="red" hide-back @onSearch="onSearch" />
		<div class="tab-wrap">
			<van-tabs v-model:active="taskState" class="tab">
				<van-tab title="待办任务" :disabled="loading" />
				<van-tab title="已办任务" :disabled="loading" />
				<van-tab title="我发起的" :disabled="loading" />
				<!--<van-tab title="回收站" :disabled="loading" />-->
			</van-tabs>
		</div>
		<List @loading="getLoadingStatus" />
	</div>
</template>
<script setup lang="ts">
import XStateHeader from '@/components/XStateHeader.vue'
import XHeaderNav from '@/components/XHeaderNav.vue'
import List from './components/list.vue'
import { useRememberScroll } from '@/hooks/remeberScroll'

const taskState = ref(0)
const router = useRouter()
const loading = ref(false)

provide('taskState', taskState)

useRememberScroll()
const onSearch = () => {
	router.push({ path: '/layout/taskSearch' })
}

const getLoadingStatus = (val) => {
	loading.value = val
}
</script>

<style scoped lang="scss">
.task {
	.tab-wrap {
		width: 100%;
		height: 44px;
		box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
		.tab {
			z-index: 2;
			position: fixed;
			width: 100%;
		}
	}
}
</style>
